





























































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { cloneDeep } from 'lodash';
import { PeriodicService } from '@/data/models/periodicservice.model';
import { DayOfTheWeek, PeriodicItem, PeriodicItemDirection, PeriodicItemWeek } from '@/data/models/periodicitem.model';
import { dateStartofDay } from '@/data/utils/helper';

@Component
export default class ServizioPeriodicoPeriod extends Vue {
	@Prop() periodicservice!: PeriodicService;
	@Prop() editable!: boolean;

	@Inject('CrudService') itemCrudService!: CrudService<PeriodicItem>;

	calendarOneway: any = {};
	calendarRoundtrip: any = {};
	week: PeriodicItemWeek = new PeriodicItemWeek();
	weekdayRoundTrip: PeriodicItemWeek = new PeriodicItemWeek();
	weekLabels!: any[]
	
	constructor() {
		super();
		this.weekLabels = Object.keys(DayOfTheWeek).filter((k: any) => isNaN(k)).map((k: any) => ({
			label: k,
			value: DayOfTheWeek[k],
		}));
	}

	mounted() {
		this.init(this.periodicservice);
	}

	init(periodicservice: PeriodicService) {
		if (periodicservice.hasPeriodicItems) {
			this.mapPeriodicItems(periodicservice.periodicitems!);
		}
	}

	mapPeriodicItems(items: PeriodicItem[]) {
		for (const item of items) {
			// enable weekday checkbox
			this.$set(this.week, item.dayoftheweek, true);

			// map periodic items into calendar objects for ui
			if (item.andataritorno === PeriodicItemDirection.ONEWAY) {
				this.$set(this.calendarOneway, item.dayoftheweek, item);
			} else if (item.andataritorno === PeriodicItemDirection.ROUNDTRIP) {
				this.weekdayRoundTrip[item.dayoftheweek] = true;
				this.$set(this.calendarRoundtrip, item.dayoftheweek, item);
			}
		}
	}

	submit() {
		const periodicItems = this.getPeriodicItems();
		this.$emit('submit', cloneDeep(periodicItems));
	}

	getPeriodicItems() {
		// get all periodic items as one array
		const items: any[] = [];
		for (const day in this.calendarOneway) {
			if (this.calendarOneway[day]) {
				const periodicitem: PeriodicItem = this.calendarOneway[day];
				items.push(periodicitem);
			}
		}
		for (const day in this.calendarRoundtrip) {
			if (this.calendarRoundtrip[day]) {
				const periodicitem: PeriodicItem = this.calendarRoundtrip[day];
				items.push(periodicitem);
			}
		}
		return items;
	}

	onCheckDay(event: boolean, day: number) {
		if (event) {
			this.onAddItemDay(day);
		} else {
			this.onRemoveItemDay(day);
		}
	}

	deletePeriodicItem(item: PeriodicItem) {
		this.itemCrudService.deleteEntity(PeriodicItem, 'periodicitem', item).then(() => {
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	onAddItemDay(day: DayOfTheWeek) {
		const periodicItem: PeriodicItem = new PeriodicItem();
		periodicItem.dayoftheweek = day;
		periodicItem.startdate = dateStartofDay(this.periodicservice.periodstartdate!);
		periodicItem.stopdate = dateStartofDay(this.periodicservice.periodenddate!);
		if (this.periodicservice.id) periodicItem.serviceid = this.periodicservice.id;
		// add periodic item to oneway map
		this.calendarOneway[day] = periodicItem;
	}

	onRemoveItemDay(day: DayOfTheWeek) {
		if (this.calendarOneway[day] && this.calendarOneway[day].id) this.deletePeriodicItem(this.calendarOneway[day]);
		if (this.calendarRoundtrip[day] && this.calendarRoundtrip[day].id) this.deletePeriodicItem(this.calendarRoundtrip[day]);

		if (this.calendarOneway[day]) this.calendarOneway[day] = undefined;
		if (this.calendarRoundtrip[day]) this.calendarRoundtrip[day] = undefined;
	}

	onRoundtrip(day: DayOfTheWeek | string) {
		// add/remove periodic item to roundtrip map based on oneway map
		if (!this.calendarRoundtrip[day]) {
			const item = cloneDeep(this.calendarOneway[day]);
			this.$set(this.calendarRoundtrip, day, item);
			this.calendarRoundtrip[day].andataritorno = PeriodicItemDirection.ROUNDTRIP;
			this.calendarRoundtrip[day].startdate = dateStartofDay(this.periodicservice.periodstartdate!);
			this.calendarRoundtrip[day].stopdate = dateStartofDay(this.periodicservice.periodenddate!);
		}
		else {
			if (this.calendarRoundtrip[day] && this.calendarRoundtrip[day].id) this.deletePeriodicItem(this.calendarRoundtrip[day]);
			this.calendarRoundtrip[day] = undefined;
		}
	}

	onSync(day: DayOfTheWeek) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-periodic-service-sync') as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.syncDates(day);
			},
		});
	}

	syncDates(day: DayOfTheWeek) {
		// sync oneway/roundtrip times across all the active weekdays
		for (const key in this.calendarOneway) {
			if (this.calendarOneway[key]) {
				const dayItem = cloneDeep(this.calendarOneway[day]);
				dayItem.startdate = this.setTimePickerDate(this.calendarOneway[day].startdate);
				dayItem.stopdate = this.setTimePickerDate(this.calendarOneway[day].stopdate);
				dayItem.dayoftheweek = Number(key);

				if (this.calendarOneway[key].id) dayItem.id = this.calendarOneway[key].id;
				else delete dayItem.id;

				this.$set(this.calendarOneway, key, dayItem);
			}
			if (this.weekdayRoundTrip[day] && !this.calendarRoundtrip[key]) {
				this.$set(this.weekdayRoundTrip, key, this.weekdayRoundTrip[day]);
				this.onRoundtrip(key);
			}
		}
		for (const key in this.calendarRoundtrip) {
			if (this.calendarRoundtrip[key]) {
				const dayItem = cloneDeep(this.calendarRoundtrip[day]);
				dayItem.startdate = this.setTimePickerDate(this.calendarRoundtrip[day].startdate);
				dayItem.stopdate = this.setTimePickerDate(this.calendarRoundtrip[day].stopdate);
				dayItem.dayoftheweek = Number(key);

				if (this.calendarRoundtrip[key].id) dayItem.id = this.calendarRoundtrip[key].id;
				else delete dayItem.id;

				this.$set(this.calendarRoundtrip, key, dayItem);
			}
		}
	}

	private setTimePickerDate(date: Date) {
		if (!date) return;
		const newDate = new Date(date.getTime());
		return newDate;
	}

}
